<template>
  <div class="qunti-huaxiang-detail child-detail">
    <ChildModal :title="$store.state.childModalTitle">
      <div class="title">

        <ul class="tab">
          <li>
            <div @click="scenicListShow = !scenicListShow" class="expand">
              <div class="icon">
                <img src="../../assets/header_menu/spot.png" />
              </div>
              <div class="drop-name">{{scenicSelected}}</div>
              <div class="arrow"></div>

              <ul class="drop-list" v-show="scenicListShow">
                <li :key="index"
                    @click="scenicSelected = item"
                    v-for="(item, index) in scenicList">
                  {{ item }}
                </li>
              </ul>
            </div>
          </li>

          <li style="width: 20px"></li>

          <li>
            <div @click="dateListShow = !dateListShow" class="expand">
              <div class="icon">
                <img src="../../assets/header_menu/time.png" />
              </div>
              <div class="drop-name">{{dateSelected}}</div>
              <div class="arrow"></div>

              <ul class="drop-list" v-show="dateListShow">
                <li :key="index"
                    @click="dateSelected = item"
                    v-for="(item, index) in dateList">
                  {{ item }}
                </li>
              </ul>
            </div>
          </li>

          <li>
            <div @click="sortListShow = !sortListShow" class="expand">
              <div class="icon">
                <img src="../../assets/sort.png" />
              </div>
              <div class="drop-name">{{sortSelected}}</div>
              <div class="arrow"></div>

              <ul class="drop-list" v-show="sortListShow">
                <li :key="index"
                    @click="sortSelected = item"
                    v-for="(item, index) in sortList">
                  {{ item }}
                </li>
              </ul>
            </div>
          </li>

          <li>
            <div @click="typeListShow = !typeListShow" class="expand">
              <div class="icon">
                <img src="../../assets/index/content.png" />
              </div>
              <div class="drop-name">{{typeSelected}}</div>
              <div class="arrow"></div>

              <ul class="drop-list" v-show="typeListShow">
                <li :key="index"
                    @click="typeSelected = item"
                    v-for="(item, index) in typeList">
                  {{ item }}
                </li>
              </ul>
            </div>
          </li>
        </ul>

        <div class="search">
          <input type="text" placeholder="输入关键词搜索" />
          <div class="search-btn"></div>
        </div>
      </div>

      <div class="subTitle" ></div>
      <div>
        <div class="subTitle">主要舆情来源</div>
        <div>
          <Bar3d  v-if="zhuyaoyuqinglaiyuanData" :id="zhuyaoyuqinglaiyuanDetailChart" :chartData="zhuyaoyuqinglaiyuanData" :style="{ height: containerSizeH, width: containerSizeW }"/>
        </div>
      </div>

      <div class="content" v-if="yuqingliebiaoData">
        <BScroll>
          <div class="subTitle" >舆情来源详情</div>
          <div class="topbar">
            <div>来源</div>
            <div>相关量</div>
            <div>占比</div>
          </div>
          <div class="wrapper">
            <BScroll>
              <ul class="table">
                <li :key="index"
                    v-for="(item, index) in yuqingliebiaoData.data"
                    @click="goSpotRealtime">
                  <div>{{ item.source }}</div>
                  <div>{{ item.count }}</div>
                  <div>{{ item.ratio }}</div>
                </li>
              </ul>
            </BScroll>
          </div>

          <div class="page">
            <PageHelper
                    @jumpPage="jumpPage"
                    :page-number="pageNumber"
            ></PageHelper>
          </div>

          <div style="height: 50px"></div>

        </BScroll>
      </div>


      <div class="zhanwei"></div>
    </ChildModal>
  </div>
</template>

<script>
import ChildModal from "@/components/Common/ChildModal.vue";
import Bar3d from "@/components/Mycharts/Bar3d.vue";
import PageHelper from "@/components/Common/PageHelper.vue";
import BScroll from "@/components/Common/BScroll.vue";


export default {
  name: "ZhuyaoyuqinglaiyuanDetail",
  components: {
    ChildModal,
    Bar3d,
    PageHelper,
    BScroll
  },
  props: {},
  data() {
    return {
      zhuyaoyuqinglaiyuanDetailChart: "zhuyaoyuqinglaiyuanDetailChart",
      zhuyaoyuqinglaiyuanData: null,
      yuqingliebiaoData: null,

      pageNumber: 1,
      sizeW: 300,
      sizeH: 200,

      scenicSelected: "黄山",
      scenicListShow: false,
      scenicList: ["黄山","泰山","衡山"],

      dateSelected: "一周内",
      dateListShow: false,
      dateList: ["一周内","一月内","三月内","一年内"],

      sortSelected: "时间",
      sortListShow: false,
      sortList: ["时间","热度"],

      typeSelected: "综合",
      typeListShow: false,
      typeList: ["综合","新闻资讯","论坛","贴吧","博客","微博","微信","OTA","视频","问答"],
    };
  },
  computed: {
    containerSizeW: function() {
      return this.sizeW + "px"

    },containerSizeH: function() {
      return this.sizeH + "px"
    }
  },
  mounted() {
    // 舆情列表数据
    fetch("/data/Lvyouyulun/YuqingzhuyaolaiyuanTableData.json")
        .then(response => {
          return response.json();
        })
        .then(json => {
          console.log("come here....data : "+ json.data.data)
          this.yuqingliebiaoData = json.data;
        });
    // 主要舆情来源
    fetch("/data/Lvyouyulun/Zhuyaoyuqinglaiyuan.json")
        .then(response => {
          return response.json();
        })
        .then(json => {
          this.zhuyaoyuqinglaiyuanData = json.data;
        });
  },
  methods: {
    closeModal() {
      this.$refs.content.style.transform = 'translate(-50%, -50%) scale(0.1)'
      setTimeout(() => {
        this.$store.commit('setSpotModalShow')
      }, 300)
    },
    jumpPage(pageinfo) {
      console.log(pageinfo);
    },
    goSpotRealtime() {
      this.closeModal();
    }
  }
};
</script>

<style scoped lang="less">
  
  .subTitle {
    height: 0.5rem;
    font-size: 0.2rem;
    color: #00cdf9;
    font-weight: bold;
    text-align: center;
  }

    #zhuyaoyuqinglaiyuanDetailChart{margin: 0 auto;
        }
  .content-box {
    padding: 0.3rem;
    box-sizing: border-box;
    /*width: 12rem;*/
    /*height: 10rem;*/
    position: absolute;
    /*left: 50%;*/
    /*top: 50%;*/
    /*transform: translate(-50%, -50%) scale(0.5);*/
    /*transition: all 0.3s;*/
    /*background: rgba(0, 0, 0, 0.5) url(../../assets/spot_bg.jpg);*/
    background-size: 100% 100%;
    box-shadow: 0 0 1.2rem rgba(0, 0, 0, 0.8);
    .title {
    height: 0.5rem;
    font-size: 0.18rem;
    color: #00cdf9;
    font-weight: bold;
    float: left;width: 100%;
      position: relative;
    .tab {
      /*width: 3.5rem;*/
      /*height: 0.3rem;*/
      /*margin: 0 auto 0.16rem;*/

      > li {
        width: 1.5rem;
        height: 0.34rem;
        line-height: 0.3rem;
        float: left;
        color: @base-text-color;
        cursor: pointer;
        > div {
          float: left;
        }
        .expand {
          /*width: 1.5rem;*/
          height: 0.3rem;
          position: absolute;
          cursor: pointer;
          > div {
            float: left;
            /*width: 0.3rem;*/
            height: 0.3rem;
            line-height: 0.3rem;
                margin-left: 0.1rem;
          }
          .local {
            width: 0.3rem;
            background: url(../../assets/youkexianxiaxingweifenxi/local.png);
            background-size: 100% 100%;
          }
          .arrow {
            width: 30px;
            height: 0.3rem;
            background: url(../../assets/header_menu/arrow.png);
            background-size: 100% 100%;
          }
          .icon {
            width: 20px;
            height: 20px;
            margin-top: -3px;
          }
          .drop-list {
            z-index: 9999;
            position: absolute;
            left: 0;
            top: 0.3rem;
            width: 100%;
            background: #052148;
            border: 1px solid #00cdff;
            padding: 0.05rem 0;
            box-sizing: border-box;
            li:hover {
              background: #0c3964;
            }
          }
        }
      }
    }
  }
  .search {
    width: 2.3rem;
    height: 0.3rem;
    position: absolute;
    top: 0;
    right: 0.3rem;
    input {
      width: 2.02rem;
      height: 0.26rem;
      background: #0e264b;
      border: 0.02rem solid #07779e;
      outline: none;
      float: left;
      padding-left: 0.1rem;
      color: #fff;
          font-size: 0.16rem;
          padding: 0.05rem;
    }
    .search-btn {
      width: 0.26rem;
      height: 0.26rem;
      float: right;
      background: rgba(0, 0, 0, 0.5) url(../../assets/spot_search_btn.jpg);
      background-size: 100% 100%;
      cursor: pointer;
    }
    input::-webkit-input-placeholder {
      color: #ccc;
    }
  }
    .content {
      overflow: hidden;
      width: 95%;
      margin: 0.5rem auto 0;
      height: 92.5%;
      box-sizing: border-box;
      .topbar {
        width: 100%;
        height: 0.38rem;
        color: @light-blue;
        font-weight: bold;
        position: relative;
        background: url(../../assets/remenluxian/table_topbar_bg.png);
        background-size: 100% 100%;
        border: 1px solid #0f84b9;
        overflow: hidden;
        > div {
          float: left;
          height: 0.36rem;
          line-height: 0.36rem;
        }
        div:nth-child(1) {
          width: 60%;
        }
        div:nth-child(2) {
          width: 20%;
          border-right: 1px solid #0f84b9;
          border-left: 1px solid #0f84b9;
        }
        div:nth-child(3) {
          width: 20%;
        }
      }
      .topbar::before {
        content: "";
        width: 0.02rem;
        height: 0.36rem;
        background: url(../../assets/remenluxian/table_topbar_line.png);
        background-size: 100% 100%;
        position: absolute;
        left: 0.04rem;
        top: 0;
      }
      .topbar::after {
        content: "";
        width: 0.02rem;
        height: 0.36rem;
        background: url(../../assets/remenluxian/table_topbar_line.png);
        background-size: 100% 100%;
        position: absolute;
        right: 0.04rem;
        top: 0;
      }
      .wrapper {
        overflow: hidden;
        width: 100%;
        height: calc(100% - 1.2rem);
      }
      .table {
        li {
          height: 0.36rem;
          line-height: 0.36rem;
          background: #07527c;
          border: 1px solid #0f84b9;
          border-bottom: none;
          font-size: 0.14rem;
          > div {
            height: 0.36rem;
            float: left;
          }
          div:nth-child(1) {
            width: 60%;
          }
          div:nth-child(2) {
            width: 20%;
            border-right: 1px solid #0f84b9;
            border-left: 1px solid #0f84b9;
          }
          div:nth-child(3) {
            width: 20%;
          }
        }
        li:nth-child(1) {
          border-top: none;
        }
        li:nth-of-type(odd) {
          background: rgba(6, 51, 81, 0.84);
        }
        li:last-child {
          border-bottom: 1px solid #0f84b9;
        }
      }
      .page {
        width: 100%;
        margin: 0 auto;
        background: #1b3e65;
      }
    }
  }
</style>
